// src/utils/audioPersistence.js
import { globalAudio } from './globalAudio';

class AudioPersistence {
  constructor() {
    this.lastState = null;
    this.isInitialized = false;
  }

  init() {
    if (this.isInitialized) return;
    
    // Load saved state from localStorage
    const savedState = localStorage.getItem('audioPlayerState');
    if (savedState) {
      try {
        const state = JSON.parse(savedState);
        this.lastState = state;
      } catch (e) {
        console.error('Error parsing saved audio state:', e);
      }
    }
    
    // Save state periodically
    setInterval(() => {
      this.saveState();
    }, 10000); // Save every 10 seconds
    
    this.isInitialized = true;
  }

  saveState() {
    const state = globalAudio.getState();
    if (state && state.currentPodcast) {
      localStorage.setItem('audioPlayerState', JSON.stringify({
        ...state,
        timestamp: Date.now()
      }));
    }
  }

  restoreState() {
    const savedState = localStorage.getItem('audioPlayerState');
    if (savedState) {
      try {
        const state = JSON.parse(savedState);
        const now = Date.now();
        const timeDiff = now - (state.timestamp || 0);
        
        // Only restore if within 5 minutes
        if (timeDiff < 5 * 60 * 1000 && state.currentPodcast) {
          return state;
        }
      } catch (e) {
        console.error('Error restoring audio state:', e);
      }
    }
    return null;
  }

  clearState() {
    localStorage.removeItem('audioPlayerState');
    this.lastState = null;
  }
}

const audioPersistence = new AudioPersistence();
export { audioPersistence };